import React from 'react'
import { FieldProps } from 'react-jsonschema-form'

const NullForm: React.FC<FieldProps> = () => {
  return null
}

export default NullForm
